export default __webpack_public_path__ + "static/media/icon_hair.25a16a8e.png";